// extracted by mini-css-extract-plugin
export default {"title":"styles_title__4zUAr","danger":"styles_danger__9yE1U","in_progress":"styles_in_progress__uQBXR","success":"styles_success__jH9jo"};